import API from "@/services/api/api.service";
import { RouteLocationNormalized } from "vue-router";

export const userResolver = async (to: RouteLocationNormalized, from: RouteLocationNormalized) => {
    try {
        const res = await API.getUser(to.params.id as string);
        to.meta.user = res.data.data;
    } catch(error) {
        console.error('PATIENT_RESOLVER_ERROR');
        return { name: 'SystemUsers' };
    }
}